/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import * as Yup from "yup";
import { useFormik } from 'formik';
import { useToast } from '../../../../components/Toats';
import { useQuery } from 'react-query';
import { KTSVG, toAbsoluteUrl } from '../../../../../../_metronic/helpers';
import { LoadingSpan } from '../../../../components/Loadings/loadingSpan';
import { ListPlantsForComposite } from '../../../../dashboard/TablePlants/components/ModalCreatePlantCompositeTable/components/ListPlantsForComposite';
import { getplantsOne, putPlantOne, putPlantOneComposite } from '../../../../../services/plantsService';
import useSize from '../../../../../hooks/useSize';

type Props = {
    show: boolean;
    handleClose: () => void;
    idPlantComposite: string | null;
    refresh: () => void;
}

const validationSchema = Yup.object().shape({
  idPlantComposite: Yup.string().required(),
  idsPlants: Yup.array().of(Yup.string()),
});

const modalsRoot = document.getElementById('root-modals') || document.body

const ModalAddSimplePlantsToComposite = ({show, handleClose, idPlantComposite, refresh}: Props) => {

  const { toggleToast } = useToast();
  const [loading, setLoading] = useState(false);
  const {width: largura} = useSize();

  const { data: compositePlant, isLoading: loadingPlant } = useQuery<any>(
    ["getCompositePlantForAdd", idPlantComposite, show],
    async () => {
      if (!idPlantComposite || !show) return null;
      const plant = await getplantsOne(idPlantComposite);
      return plant;
    },
    {
      enabled: show && !!idPlantComposite,
      onError: (error) => {
        console.log(error);
        toggleToast("Erro ao buscar a usina composta.", "error");
      },
    }
  );

  const linkedPlantsIds = compositePlant?.childPlants 
    ? compositePlant.childPlants.map((child: any) => child.id)
    : [];

  const [initialValues] = useState<any>({
    idPlantComposite: null,
    idsPlants: [],
  })

  const addPlantsToComposite = async () => {
    try {
      setLoading(true);
      
      if (!formik.values.idPlantComposite || !formik.values.idsPlants || formik.values.idsPlants.length === 0) {
        toggleToast("Selecione pelo menos uma usina para adicionar.", "warning");
        return;
      }
      
      const allIds = [...new Set([...linkedPlantsIds, ...formik.values.idsPlants])];
      
      const body = {
        idsChildPlants: allIds,
        //idsChildPlants: formik.values.idsPlants
      };
      await putPlantOneComposite(formik.values.idPlantComposite, body);
      
      toggleToast("Usinas adicionadas com sucesso à usina composta.", "success");

    } catch (error) {
      console.log(error);
      toggleToast("Erro ao adicionar usinas à usina composta.", "error");
    } finally {
        refresh();
        closed();
        setLoading(false);
    }
  }

  const submit = () => {
    addPlantsToComposite();
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: false,
    onSubmit: submit,
  });

  const closed = () => {
    formik.resetForm();
    handleClose();
  }

  useEffect(() => {
    if (compositePlant && idPlantComposite) {
      formik.setValues({
        idPlantComposite: idPlantComposite,
        idsPlants: [],
      });
    }
  }, [compositePlant, idPlantComposite]);
  
  
  return createPortal(
    <Modal
      id='kt_modal_add_simple_plants'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={closed}
      backdrop={true}
    >
      <div className='modal-header'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Adicionar Usinas SIMPLES</span>
        </h3>

        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={closed}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        {loadingPlant ? (
          <div className='d-flex align-items-center justify-content-center' style={{height: '20rem'}}>
            <LoadingSpan />
          </div>
        ) : (
          <>
            {compositePlant && (
              <div className='d-flex align-items-center mb-7 p-4 bg-light rounded'>
                <div className='d-flex align-items-center' style={{flex: '4'}}>
                  <div className={`symbol symbol-${largura < 1200 ? '40px' : '70px'} me-5`}>
                    <span className='symbol-label' style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <div className={`symbol symbol-${largura < 1200 ? '40px' : '70px'}`} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <img src={toAbsoluteUrl('/media/imgs/plantComposite.png')} className='' alt='' />
                      </div>
                    </span>
                  </div>
                  <div className='d-flex flex-column'>
                    <a href='#' className={`text-dark text-hover-primary fs-${largura < 1200 ? '7' : '6'} fw-bold`}>
                      {compositePlant.name}
                    </a>
                    <span className={`text-muted fw-semibold fs-${largura < 1200 ? '7' : '6'}`}>
                      {compositePlant.address ? compositePlant.address : "Não localizado."}
                    </span>
                    {compositePlant.mark && (
                      <span className={`text-muted fw-semibold d-flex align-items-center gap-2 fs-${largura < 1200 ? '7' : '6'}`}>
                        <span className='fw-bold text-gray-600'>Marca (PORTAL): </span>
                        <div className={`symbol symbol-30px`} style={{cursor: 'pointer'}} title={compositePlant.mark.name ? compositePlant.mark.name : ""}>
                          <img src={toAbsoluteUrl(compositePlant.mark.link_imagem ? compositePlant.mark.link_imagem : "/media/imgs/plant2.png")} className='' alt='' />
                        </div>
                      </span>
                    )}
                    <span className='text-primary fw-semibold fs-7 mt-1'>
                      Usina COMPOSTA
                    </span>
                  </div>
                </div>
              </div>
            )}

            <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed flex-shrink-0 p-6 mb-5'>
              <KTSVG
                path='/media/icons/duotune/general/gen044.svg'
                className='svg-icon-2tx svg-icon-warning me-4'
              />
              <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
                <div className='mb-3 mb-md-0 fw-bold'>
                  <div className='fs-6 text-warning pe-7'>
                    Para vincular usinas SIMPLES em COMPOSTAS, é necessario selecionar apenas 1 usina por marca (portal).  
                  </div>
                </div>
              </div>
            </div>

            <ListPlantsForComposite
              className=''
              formik={formik}
              idUnitBranch={compositePlant?.unitBranch?.id || null}
              show={show}
              linkedPlantsIds={linkedPlantsIds}
            />
          </>
        )}
      </div>

      <div className='modal-footer py-lg-10 px-lg-10'>
        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
            <button
                type='button'
                className='btn btn-lg btn-light'
                disabled={loading}
                onClick={closed}
            >
                <KTSVG
                    path='/media/icons/duotune/arrows/arr063.svg'
                    className='svg-icon-3 ms-2 me-0'
                />
                <span style={{marginLeft: '0.5rem'}}>Cancelar</span>
            </button>

            <button
                type='button'
                className='btn btn-lg btn-primary'
                disabled={loading || !formik.values.idPlantComposite || !formik.values.idsPlants || formik.values.idsPlants.length === 0}
                onClick={submit}
            >
                Adicionar Usinas
                {
                    loading ? 
                    <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                    :
                    <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 ms-2 me-0'
                    />
                }
            </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalAddSimplePlantsToComposite}
